import { useMAXAuth } from "@/hooks/useMAXAuth";
import { MAXAuthGate } from "./MAXAuthGate";

/**
 * Mounts the MAX Mini-App auth flow.
 * Detects initData in URL, validates via edge function, sets Supabase session.
 * Renders nothing when no initData is present.
 */
export function MAXAuthBootstrap() {
  const { status, error, retry } = useMAXAuth();
  return <MAXAuthGate status={status} error={error} onRetry={retry} />;
}
